import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import { AnyAction } from "redux";
import { AccountState } from "../../../../../models/state";
import { actionTypes as AUTH_AT } from "../../../authentication";
import { pending, fulfilled, rejected } from "../../utils";
import * as AT from "../actionTypes";

const initialState = (): AccountState => ({
    current: {
        id: "",
        messages: [],
    },
    transfer: {
        existingLegalOwnerVerified: false,
        canSendOrder: false,
        hasSentOrder: false,
        hasSubmittedOrder: false,
        agreementsToKeep: {},
        existingLeases: [],
    },
    accountIdsWithTypes: [],
    relatedAccounts: [],
    selectedAccount: "",
    setMemberSuccess: false,
});

const reducer = (state = initialState(), action: AnyAction) => {
    switch (action.type) {
        case fulfilled(AT.CHECKOUT_CHECK_NEW_MEMBER_PHONE_NUMBER):
            return {
                ...state,
                current: {
                    id: action.payload.id,
                    messages: action.payload.messages,
                },
                accountIdsWithTypes: _isEmpty(action.payload.cart?.accountIdsWithTypes)
                    ? state.accountIdsWithTypes
                    : action.payload.cart.accountIdsWithTypes,
            };
        case fulfilled(AT.CHECKOUT_SET_SELECTED_ACCOUNT):
            return {
                ...state,
                selectedAccount: action.payload.selectedAccount,
            };
        case fulfilled(AT.CHECKOUT_RESET_MEMBER):
            return {
                ...state,
                current: {
                    ...initialState().current,
                    id: _get(state, "current.id") || action.payload.currentMemberId || null,
                },
            };
        case AT.CHECKOUT_CHOOSE_PHONE_NUMBER_SWITCH_PANEL:
            return {
                ...state,
                current: {
                    ...state.current,
                    messages: [],
                },
            };
        case pending(AT.CHECKOUT_SET_MEMBER_DETAILS):
        case rejected(AT.CHECKOUT_SET_MEMBER_DETAILS):
            return {
                ...state,
                setMemberSuccess: false,
            };
        case fulfilled(AT.CHECKOUT_SET_MEMBER_DETAILS):
            if (action.payload.hasUpdatedMember) {
                return {
                    ...state,
                    current: {
                        ...initialState().current,
                        id: action.payload.currentMemberId,
                    },
                    accountIdsWithTypes: _isEmpty(action.payload?.accountIdsWithTypes)
                        ? state.accountIdsWithTypes
                        : action.payload.accountIdsWithTypes,
                    setMemberSuccess: true,
                };
            }
            return state;
        case fulfilled(AT.CHECKOUT_ADD_SUBSCRIPTION_TO_CART):
        case fulfilled(AT.CHECKOUT_REMOVE_ITEM_BY_ID_FROM_CART):
            if (_isEmpty(action.payload?.accountIdsWithTypes)) {
                return state;
            }
            return {
                ...state,
                accountIdsWithTypes: action.payload.accountIdsWithTypes,
            };
        case fulfilled(AT.CHECKOUT_VERIFY_CODE_TRANSFER_OWNERSHIP):
            return {
                ...state,
                transfer: {
                    ...state.transfer,
                    existingLegalOwnerVerified: true,
                },
            };
        case fulfilled(AUTH_AT.AUTH_BANK_ID_GRANT):
            return {
                ...state,
                accountIdsWithTypes: _get(action, "payload.accountIdsWithTypes", []),
            };
        case fulfilled(AT.CHECKOUT_VERIFY_CODE_TRANSFER_OWNERSHIP_EXISTING_COMPANY_ADMIN):
            return {
                ...state,
                transfer: {
                    ...state.transfer,
                    existingLegalOwnerVerified: true,
                    verifiedCompanyAdmin: `${_get(action.payload, "firstName", "")} ${_get(
                        action.payload,
                        "lastName",
                        "",
                    )}`.trim(),
                },
            };
        case AT.CHECKOUT_SET_CAN_SEND_TRANSFER_ORDER:
            return {
                ...state,
                transfer: {
                    ...state.transfer,
                    canSendOrder: action.payload.canSendOrder,
                },
            };
        case fulfilled(AT.CHECKOUT_SEND_SMS):
            return {
                ...state,
                transfer: {
                    ...state.transfer,
                    hasSentOrder: true,
                },
            };
        case fulfilled(AT.CHECKOUT_SUBMIT_TRANSFER_OWNERSHIP_ORDER):
            return {
                ...state,
                transfer: {
                    ...state.transfer,
                    hasSubmittedOrder: true,
                    hasRejectedOrder: false,
                },
            };
        case fulfilled(AT.TRANSFER_APPROVE_FROM_FORMER_LEGAL):
            return {
                ...state,
                transfer: {
                    ...state.transfer,
                    hasSubmittedOrder: true,
                    hasRejectedOrder: false,
                },
            };
        case fulfilled(AT.TRANSFER_REJECT_FROM_FORMER_LEGAL):
            return {
                ...state,
                transfer: {
                    ...state.transfer,
                    hasSubmittedOrder: false,
                    hasRejectedOrder: true,
                },
            };
        case fulfilled(AT.CHECKOUT_UPDATE_ORG_CONSENT_TO_B2B):
            return {
                ...state,
                transfer: {
                    ...state.transfer,
                    hasSubmittedOrder: false,
                    hasRejectedOrder: false,
                },
            };
        case fulfilled(AT.CHECKOUT_UPDATE_FORMER_LEGAL_B2B):
            return {
                ...state,
                transfer: {
                    ...state.transfer,
                    hasSubmittedOrder: false,
                    hasRejectedOrder: false,
                },
            };
        case fulfilled(AT.CHECKOUT_REJECT_TRANSFER_OWNERSHIP_ORDER):
            return {
                ...state,
                transfer: {
                    ...state.transfer,
                    hasSubmittedOrder: false,
                    hasRejectedOrder: true,
                },
            };
        case fulfilled(AT.CHECKOUT_SUBMIT_PORTIN_DATA):
            return {
                ...state,
                transfer: {
                    ...state.transfer,
                    hasSubmittedPortinData: true,
                },
            };
        case fulfilled(AT.CHECKOUT_SET_OFFERING_CODE):
            return {
                ...state,
                transfer: {
                    ...state.transfer,
                    selectedOfferingCode: action.payload.selectedOfferingCode,
                },
            };
        case fulfilled(AT.CHECKOUT_SET_TRANSFER_DATE):
            return {
                ...state,
                transfer: {
                    ...state.transfer,
                    selectedTransferDate: action.payload.selectedTransferDate,
                },
            };
        case fulfilled(AT.CHECKOUT_CHECK_EXISTING_PHONE_NUMBER):
            return {
                ...state,
                accountId: action.payload.accountId,
            };
        case fulfilled(AT.CHECKOUT_SET_KEEP_AGREEMENT):
            return {
                ...state,
                transfer: {
                    ...state.transfer,
                    agreementsToKeep: {
                        ...state.transfer.agreementsToKeep,
                        [action.payload.type]: action.payload.keepAgreement,
                    },
                },
            };
        default:
            return state;
    }
};

export default reducer;
